/**
 * fantasyMaps — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {LANDSCAPE, tagline, chips, type ToilePack} from './data'

export const fantasyMapsPack: ToilePack = {
    slug: 'fantasy-maps',
    category: 'maps',
    name: 'Fantasy maps',
    tagline: tagline('maps', 'worlds', 'cartography styles'),
    chips: chips('worlds', 'styles'),
    ratio: LANDSCAPE,
    readings: [
        {key: 'archipelago', label: 'Archipelago', subject: 'a volcanic archipelago, a sea-serpent, a port town'},
        {key: 'kingdom', label: 'River kingdom', subject: 'a river kingdom, a walled capital, mountains to the north'},
        {key: 'dungeon', label: 'Dungeon', subject: 'a multi-room dungeon beneath a ruined keep'},
    ],
    styles: [
        {key: 'parchment', label: 'Parchment', style: 'hand-inked on aged parchment, sepia ink', palette: 'sepia, hatched mountains', framing: 'compass rose, no legible text'},
        {key: 'isometric', label: 'Isometric', style: 'isometric illustrated map, painted terrain', palette: 'tiny buildings and trees in 3D', framing: 'compass rose, no legible text'},
        {key: 'blueprint', label: 'Blueprint', style: 'clean top-down blueprint, measured grid', palette: 'white lines on deep blue', framing: 'compass rose, no legible text'},
    ],
    directions: ['a frozen north instead', 'in cool blue-grey inks', 'aged and torn'],
}
